import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  textArea: {
    boxSizing: 'inherit',
    minWidth: '-webkit-fill-available',
    maxWidth: '-webkit-fill-available',
    fontSize: 'large',
    minHeight: 150,
    width: 'inherit',
    resize: 'none',
    backgroundColor: theme.palette.brand.grey,
    borderRadius: theme.spacing(1),
  },
}));

export default function Comment({
  commentId,
  placeholder,
  maxLength,
  defaultValue,
  onChangeFunc,
}) {
  const moveCaretToTheEnd = (e) => {
    const tempValue = e.target.value;
    e.target.value = '';
    e.target.value = tempValue;
  };

  const classes = useStyles();
  return (
    <textarea
      onChange={onChangeFunc}
      autoFocus
      onFocus={moveCaretToTheEnd}
      placeholder={placeholder}
      defaultValue={defaultValue}
      name={commentId}
      id={commentId}
      className={classes.textArea}
      maxLength={maxLength}
    />
  );
}
